import React, { useState } from "react";
import { Lock, Delete } from "lucide-react";
import { verifyPin, markUnlocked } from "@/lib/appLock";

export default function LockScreen({ onUnlock }) {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState(false);

  const press = async (d) => {
    if (pin.length >= 4) return;
    const next = pin + d;
    setPin(next);
    setErr(false);
    if (next.length === 4) {
      if (await verifyPin(next)) {
        markUnlocked();
        onUnlock();
      } else {
        setErr(true);
        setTimeout(() => setPin(""), 450);
      }
    }
  };
  const back = () => setPin((p) => p.slice(0, -1));

  return (
    <div className="fixed inset-0 z-[200] bg-[var(--rc-bg)] flex flex-col items-center justify-center px-8" data-testid="lock-screen">
      <div className="h-16 w-16 rounded-2xl grid place-items-center border-2 border-[var(--rc-gold)] text-[var(--rc-gold)] mb-5">
        <Lock size={28} />
      </div>
      <h2 className="font-heading text-xl text-[var(--rc-text)]">RoyalChat Nova locked</h2>
      <p className="text-sm text-[var(--rc-muted)] mb-6">Enter your PIN to continue</p>

      <div className={`flex gap-4 mb-8 ${err ? "animate-shake" : ""}`}>
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`h-3.5 w-3.5 rounded-full border ${i < pin.length ? "bg-[var(--rc-gold)] border-[var(--rc-gold)]" : "border-[var(--rc-muted)]"} ${err ? "border-red-500" : ""}`} />
        ))}
      </div>

      <div className="grid grid-cols-3 gap-4 w-full max-w-[280px]">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <button key={n} onClick={() => press(String(n))} data-testid={`pin-${n}`}
            className="h-16 rounded-full bg-[var(--rc-surface)] border border-[var(--rc-border)] text-2xl font-heading text-[var(--rc-text)] active:bg-[var(--rc-surface-2)]">
            {n}
          </button>
        ))}
        <span />
        <button onClick={() => press("0")} data-testid="pin-0" className="h-16 rounded-full bg-[var(--rc-surface)] border border-[var(--rc-border)] text-2xl font-heading text-[var(--rc-text)] active:bg-[var(--rc-surface-2)]">0</button>
        <button onClick={back} data-testid="pin-back" className="h-16 rounded-full grid place-items-center text-[var(--rc-muted)] active:text-[var(--rc-gold)]"><Delete size={22} /></button>
      </div>
    </div>
  );
}
